import React, { useEffect, useState } from 'react';

import { hasActiveFilter } from './unallocatedSummaryTree';

import FormInput from 'CommonComponents/FormInput';
import TableFilterModal from 'CommonComponents/TableFilterModal';

export const EMPTY_FILTER = { minPercent: '', minBalance: '' };

/**
 * Lower bounds on the unallocated criteria, combined as AND. Editing is held in
 * draft state so a half-typed threshold does not re-filter the table on every
 * keystroke — the panel applies on Apply, and Clear resets both.
 */
export default function UnallocatedExpensesIndexFilter({ filter, onApply }) {
    const [draft, setDraft] = useState(filter);

    // The applied filter can change without going through this panel — the empty
    // state's Clear link resets it directly. Without this the panel would reopen still
    // showing thresholds that are no longer applied, and Apply would silently put them
    // back.
    useEffect(() => setDraft(filter), [filter]);

    // React 16 pools synthetic events, so the value has to be read now — by the time
    // the state updater runs the event is released and event.target is null.
    const change = (key) => (event) => {
        const { value } = event.target;
        setDraft((previous) => ({ ...previous, [key]: value }));
    };

    return (
        <TableFilterModal
            headerText={$t('Filter unallocated')}
            isActive={hasActiveFilter(filter)}
            showCancel
            cancelText={$t('Clear')}
            onApply={() => onApply(draft)}
            onCancel={() => {
                setDraft(EMPTY_FILTER);
                onApply(EMPTY_FILTER);
            }}
        >
            <div className="tw-min-w-80 tw-space-y-4">
                <FormInput
                    type="number"
                    id="min_percent"
                    name="min_percent"
                    label={$t('Minimum unallocated %')}
                    placeholder={$t('Any')}
                    value={draft.minPercent}
                    onChange={change('minPercent')}
                />
                <FormInput
                    type="number"
                    id="min_balance"
                    name="min_balance"
                    label={$t('Minimum unallocated balance')}
                    placeholder={$t('Any')}
                    value={draft.minBalance}
                    onChange={change('minBalance')}
                />
                <p className="tw-text-2xs tw-text-charcoal-50">
                    {$t('Totals are recalculated over the rows that match. A department or cost centre with no matching projects is hidden.')}
                </p>
            </div>
        </TableFilterModal>
    );
}
